const night = ['IMG_0112.JPG',
'IMG_0118.JPG',
'IMG_0142.JPG',
'IMG_0153.JPG',
'IMG_0220.JPG',
'IMG_0223.JPG',
'IMG_0233.JPG',
'IMG_0238.JPG',
'IMG_0246.JPG',
'IMG_0247.JPG',
'IMG_0248.JPG',
'IMG_0254.JPG',
'IMG_0255.JPG',
'IMG_0995.JPG',
'IMG_1003.JPG',
'IMG_1307.JPG',
'IMG_1317.JPG',
'IMG_1617.JPG',
'IMG_1752.JPG',
'IMG_1806.JPG',
'IMG_1813.JPG',
'IMG_1816.JPG',
'IMG_1856.JPG',
'IMG_2577.JPG',
'IMG_3043.JPG',
'IMG_3373.JPG',
'IMG_3553.JPG',
'IMG_3665.JPG',
'IMG_3967.JPG',
'IMG_3985.JPG',
'IMG_4223.JPG',
'IMG_4491.JPG',
'IMG_4492.JPG',
'IMG_4495.JPG',
'IMG_4502.JPG',
'IMG_4503.JPG',
'RebelXS_IMG_0525.JPG',
'RebelXS_IMG_0530.JPG',
'RebelXS_IMG_0534.JPG',
'RebelXS_IMG_0535.JPG',
'RebelXS_IMG_0539.JPG',
'RebelXS_IMG_0548.JPG',
'RebelXS_IMG_0550.JPG',
'RebelXS_IMG_0558.JPG',
'RebelXS_IMG_1076.JPG',
'RebelXS_IMG_1268.JPG',
'RebelXS_IMG_1269.JPG',
'RebelXS_IMG_2356.JPG',
'RebelXS_IMG_2395.JPG',
'RebelXS_IMG_2629.JPG',
'RebelXS_IMG_2631.JPG',
'RebelXS_IMG_2822.JPG',
'iPhone2G_IMG_0031.JPG',
'iPhone2G_IMG_0038.JPG',
'iPhone2G_IMG_0454.JPG'];

export default night;